export default __webpack_public_path__ + "e10d0e8b683076ae47e62f0da90f8de0.svg";